// extracted by mini-css-extract-plugin
export default {"container":"shareBlock_container__NHaIs","title":"shareBlock_title__pLBrN","input":"shareBlock_input__UvT1P","buttonGroup":"shareBlock_buttonGroup__-SA3G"};